<footer class="footer py-large px-medium text-center text-grayscale-white text-xsmall">
    <div class="container grid">
        <strong class="footer__title grid-12 text-center mb-thumb">Contáctenos</strong>
        <ul class="footer__icons-list grid grid-12">
            <li class="grid-6 grid-sm-3">
                <a rel=noopener href="https://www.facebook.com/ciencuadras" target="_blank" class="d-flex ai-center text-grayscale-white"><span
                        class="icon-facebook22 pr-xsmall text-small"></span>Facebook</a>
            </li>
            <li class="grid-6 grid-sm-3">
                <a rel=noopener href="https://www.instagram.com/ciencuadras/" target="_blank" class="d-flex ai-center text-grayscale-white"><span
                        class="icon-instagram pr-xsmall text-small"></span>Instagram</a>
            </li>
            <li class="grid-6 grid-sm-3">
                <a rel=noopener href="https://twitter.com/ciencuadras/" target="_blank" class="d-flex ai-center text-grayscale-white"><span
                        class="icon-twitter pr-xsmall text-small"></span>Twitter</a>
            </li>
            <li class="grid-6 grid-sm-3">
                <button class="d-flex ai-center text-grayscale-white" (click)="openContactenosDialog()" name="contactenos">
                    <span class="icon-mail2 pr-xsmall text-small">
                    </span>Contáctenos</button>
            </li>
        </ul>
        <ul class="footer__nav-list d-block d-lg-flex grid-12 jc-space-evenly">
            <li class="list-item">
                <a rel=noopener href="https://www.ciencuadras.com/terminos-y-condiciones" target="_blank" class="text-grayscale-white">Términos y condiciones generales</a>
            </li>
            <li class="list-item">
                <a rel=noopener  href=" https://www.ciencuadras.com/terminos-y-condiciones-especiales" target="_blank" class="text-grayscale-white">Términos y condiciones especiales</a>
            </li>
            <li class="list-item">
                <a rel=noopener  href="https://www.ciencuadras.com/politicas-de-datos-personales" target="_blank" class="text-grayscale-white">Política de tratamiento de datos personales</a>
            </li>
            <li class="list-item">
                <a rel=noopener  href="https://www.ciencuadras.com/aviso-de-privacidad" target="_blank" class="text-grayscale-white">Aviso de privacidad</a>
            </li>
            <li class="list-item">
                <a rel=noopener  href="https://www.ciencuadras.com/reglas-de-juego " target="_blank" class="text-grayscale-white">Reglas de juego</a>
            </li>
        </ul>
        <p class="footer__copyright grid-12">CIENCUADRAS.COM Avenida Calle 26 # 69 76 Torre 1 Piso 13 Centro Empresarial Elemento de la ciudad de Bogotá D.C
            <br>Ciencuadras es una marca registrada del Grupo Bolívar S.A. Prohibida su reproducción total o parcial, así como su traducción a otro idioma</p>
    </div>
</footer>